export const COMMIT_TO_MEZZO = 'commit_to_mezzo'
export const IN_PROGRESS = 'in_progress'
export const NOT_SAVED = 'not_saved'
export const COMPLETE = 'complete'
export const DELETING = 'deleting'
